import { AlignLeftOutlined, EnvironmentOutlined } from "@ant-design/icons";
import TextIcon from "@/assets/icons/data_text.svg?react";
import NumericListIcon from "@/assets/icons/data_numeric.svg?react";
import StatusIcon from "@/assets/icons/data_status.svg?react";
import CalendarIcon from "@/assets/icons/data_datetime.svg?react";
import type { FilterType } from "./filterTypes";

export const getIconForDataType = (dataType: FilterType) => {
  const iconProps = { className: "shrink-0" };

  switch (dataType) {
    case "text_array":
    case "text":
    case "boolean":
      return <TextIcon {...iconProps} />;
    case "numeric":
      return <NumericListIcon {...iconProps} />;
    case "datetime":
      return <CalendarIcon {...iconProps} />;
    case "categorical":
      return <StatusIcon {...iconProps} />;
    case "geo":
      return <EnvironmentOutlined {...iconProps} />;
    default:
      return <AlignLeftOutlined {...iconProps} />;
  }
};
